import React, { useState } from 'react';
import { doc, setDoc, getFirestore } from 'firebase/firestore';

import Navigation from '../Navigation/Navigation';

import profpic from '../../Images/Andy.jpeg';

const Contact = ({navigate,dimensions,width}) => {
	const [ name, setName ] = useState('');
	const [ email, setEmail ] = useState('');
	const [ subject, setSubject ] = useState('');
	const [ message, setMessage ] = useState('');


	function outputName(e) { setName(e.target.value) }
	function outputEmail(e) { setEmail(e.target.value) }
	function outputSubject(e) { setSubject(e.target.value) }
	function outputMessage(e) { setMessage(e.target.value) }

	async function sendMessage() {
		const db = getFirestore();
		const id = String(Math.round(Math.random()*10001204));
		const obj = {
			id: id,
			name: name,
			email: email,
			subject: subject,
			message: message,
			date: String(new Date()),
		}
		await setDoc(doc(db, 'messages', id), obj);
		window.location.reload(false);
		return null
	}

	let className = 'flexHeightCenter';
	let textWide = width-150;
	if(dimensions.width < 600){
		className = '';
		textWide = width;
	}
	return(
		<div>
			<Navigation navigate={navigate} width={width} />
			{/*{projectLoop()}*/}
			<div style={{height:60}}></div>

			<div style={{width:width,margin:'auto'}}>
				
				<div style={{height:30}}></div>
				<div className={className}>
					<div style={{width:120,height:120,borderRadius:120,overflow:'hidden',marginRight:30}} className='flexCenter'>
						<img src={profpic} alt='profpic' style={{width:'100%'}} />
					</div>
					<div style={{width:textWide}}>
						<div className='heading bold' style={{marginBottom:10}}>Contact</div>
						<div className='subHeading fadeIn'>Any questions? Feel free to send me an email</div>
					</div>
				</div>
				<div style={{height:20}}></div>
				<div className='bold mainText' style={{marginBottom:10,marginTop:20}}>Name:</div>
				<input onChange={outputName} value={name} placeholder='John Smith...' className='input' style={{width:'100%'}} />
				<div className='bold mainText' style={{marginBottom:10,marginTop:20}}>Email:</div>
				<input onChange={outputEmail} value={email} placeholder='John Smith...' className='input' style={{width:'100%'}} />
				<div className='bold mainText' style={{marginBottom:10,marginTop:20}}>Subject:</div>
				<input onChange={outputSubject} value={subject} placeholder='John Smith...' className='input' style={{width:'100%'}} />
				<div className='bold mainText' style={{marginBottom:10,marginTop:20}}>Message:</div>
				<textarea onChange={outputMessage} value={message} placeholder='John Smith...' className='textArea' style={{width:'100%'}} />
				{name === '' || email === '' || message === ''
					? <div className='flexCenter' style={{background:'rgb(0,140,255)',color:'white',height:40,borderRadius:4,marginTop:16,opacity:0.5}}>Send</div>
					: <div className='pointer flexCenter' style={{background:'rgb(0,140,255)',color:'white',height:40,borderRadius:4,marginTop:16}}
						onClick={sendMessage}>Send</div>
				}
				
			</div>
			<div style={{height:80}}></div>
		</div>
	)
}

export default Contact;